import { createContext } from 'react';

export interface DataGridContextValues {
  rows: any[];
}

const DataGridContext = createContext<DataGridContextValues | null>(null);

export default DataGridContext;
